import { useTranslation } from "react-i18next";
import MarketingHeader from "@/components/layout/MarketingHeader";
import HeroSection from "@/components/home/HeroSection";
import ValuePillarsSection from "@/components/home/ValuePillarsSection";
import HowItWorksSection from "@/components/home/HowItWorksSection";
import WhyNowSection from "@/components/home/WhyNowSection";
import DutyOfCareSection from "@/components/home/DutyOfCareSection";
import ProductDemoSection from "@/components/home/ProductDemoSection";
import TrustComplianceSection from "@/components/home/TrustComplianceSection";
import TestimonialsSection from "@/components/home/TestimonialsSection";
import FinalCTASection from "@/components/home/FinalCTASection";
import { SEO } from "@/components/seo/SEO";
import { StructuredData, organizationSchema, websiteSchema, softwareApplicationSchema } from "@/components/seo/StructuredData";

const Home = () => {
  const { t } = useTranslation();

  return (
    <>
      <SEO 
        title={t('seo.homeTitle')}
        description={t('seo.homeDescription')}
        canonical="https://renest.fr/"
      />
      <StructuredData data={[organizationSchema, websiteSchema, softwareApplicationSchema]} />
      
      <MarketingHeader />
      <div className="min-h-screen bg-background pt-16">
      
      {/* 1. Hero Section - Updated with WorkFlex-inspired copy */}
      <HeroSection />
      
      {/* 2. Value Pillars - 3 columns (Compliance, Experience, Control) */}
      <ValuePillarsSection />
      
      {/* 3. How It Works - 5-step visual flow */}
      <HowItWorksSection />
      
      {/* 4. Product Demo Section - Platform screenshots */}
      <ProductDemoSection />
      
      {/* 5. Why Now Section - Risk escalation */}
      <WhyNowSection />
      
      {/* 6. Duty of Care & SOS Section */}
      <DutyOfCareSection />
      
      {/* 7. Trust & Compliance Section */}
      <TrustComplianceSection />
      
      {/* 8. Testimonials Section */}
      <section className="py-16 sm:py-24 px-4 bg-muted/30">
        <div className="container mx-auto">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4 sm:mb-6">
              {t('testimonials.title')}
            </h2>
            <p className="text-lg sm:text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed px-4">
              {t('testimonials.subtitle')}
            </p>
          </div>
          <TestimonialsSection />
        </div>
      </section>
      
      {/* 9. Final CTA Section - "The future of workation starts with Renest" */}
      <FinalCTASection />
      </div>
    </>
  );
};

export default Home;
